module.exports = __webpack_public_path__ + "img/hr-sand-decal-28.8e746e56.png";